import firebase from 'firebase'
import SystemConstants from '@app/constants/SystemConstants'
import urls from '@app/plugins/urls'
import { accountModule, authModule } from '@app/store'
import { isAuth } from '@app/utils/auth'
import { UserStatus } from '@app/types/src/account'
export default async function ({
  app,
  store,
  route,
  redirect,
}: {
  app: any
  store: any
  route: any
  redirect: any
}) {
  console.log(`[middleware] importUser`)
  const account = await accountModule.getUser()
  if (account.temporary_password_flag == '1') {
    localStorage.setItem(SystemConstants.redirectKey, route.fullPath)
    redirect(urls.passwordReset + '?tmp_password=1')
  }
}
